import { FC } from "react";

const NotAuth: FC = () => {
  return <div>NotAuth</div>;
};

export default NotAuth;
